<template>
  <CardRow
    :label="label"
    :value="value"
    :disabled="disabled"
    :is-edit-mode-disabled='isEditModeDisabled'
    :error-messages="hint ? [] : errorMessages"
    :required="required"
    :hideBorderBottom="hideBorderBottom"
  >
    <UITextField
      v-model="dataValue"
      hide-details
      :errorMessages="errorMessages"
      :placeholder="placeholder"
      :disabled="disabled"
      :type="type"
      :hint="hint"
      :persistent-hint="persistentHint"
      :useVmaskForNumber="useVmaskForNumber"
      @change="change"
      @input="input"
    />
  </CardRow>
</template>

<script>
import CardRow from './CardRow'
import UITextField from '../UITextField'

export default {
  name: 'CardFieldRow',

  props: {
    label: String,
    value: {
      type: String | Number | null | undefined,
      default: ''
    },
    type: {
      String,
      default: 'text'
    },
    useVmaskForNumber: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isEditModeDisabled: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Array
    },
    required: {
      type: Boolean,
      default: false
    },
    hideBorderBottom: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Введите значение'
    },
    hint: {
      type: String,
      default: ''
    },
    persistentHint: {
      type: Boolean,
      default: false
    }
  },

  components: {
    UITextField,
    CardRow
  },

  data: () => {
    return {
      dataValue: null
    }
  },

  methods: {
    change(val) {
      this.$emit('change', val)
    },
    input(val) {
      this.$emit('input', val)
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.dataValue = val
      }
    }
  }
}
</script>

<style scoped></style>
